var _excluded = ["text", "appearance", "shape"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { ButtonAppearance, ButtonShape } from '@tablekit/button';
import { AlertFooterContainer, AlertFooterButton } from '../styled.js';
import { jsx } from '@emotion/react/jsx-runtime';

var AlertFooter = function AlertFooter(_ref) {
  var actions = _ref.actions;
  return jsx(AlertFooterContainer, {
    children: actions.map(function (action) {
      var text = action.text,
          _action$appearance = action.appearance,
          appearance = _action$appearance === void 0 ? ButtonAppearance.Subtle : _action$appearance,
          _action$shape = action.shape,
          shape = _action$shape === void 0 ? ButtonShape.Circular : _action$shape,
          otherProps = _objectWithoutProperties(action, _excluded);

      return jsx(AlertFooterButton, _objectSpread(_objectSpread({
        appearance: appearance,
        shape: shape
      }, otherProps), {}, {
        children: text
      }), text);
    })
  });
};

export { AlertFooter };
